import AdditionalInfo from "./additionalInfo.container";

export default AdditionalInfo;
